import React from "react";
import { PhishNetLogo } from "@ui/components";
import { Container } from "../portalInstructions/styled"

export const Logout = () => {
  return (
    <Container>
      <PhishNetLogo />
    </Container>
  )
}
